import bannerWebKilos from '@/assets/banners/es/fto_bannerweb_kilos_2880x1145px.png'
import bannerColorinMango from '@/assets/banners/es/fto_bannerweb_colorin_mango_-2880x1145px.png'
import bannerLineaTaco from '@/assets/banners/es/fto_bannerweb_linea_taco_2880x1145px.png'
import bannerVolcanes from '@/assets/banners/es/fto_banner_web_volcanes_2880x1145px.png'
import bannerConsome from '@/assets/banners/es/fto_banner_web_promo_wa_consome_2880x1145.png'

const pathImgBanner = [
    {
        id: '1',
        imgEsp: bannerWebKilos,
        imgEng: bannerWebKilos
    },
    {
        id: '2',
        imgEsp: bannerColorinMango,
        imgEng: bannerColorinMango
    },
    {
        id: '3',
        imgEsp: bannerLineaTaco,
        imgEng: bannerLineaTaco
    },
    {
        id: '4',
        imgEsp: bannerVolcanes,
        imgEng: bannerVolcanes
    },
]

export default pathImgBanner